import React, { useState } from "react";

// project-imports
import { useTestimonialContext } from "../../context/testimonial_context";
import {
  GoogleAnalyticsEnum,
  triggerFunction,
} from "../../utils/google-analytics";

// Child Component
const Result = () => {
  return (
    <p className="success-message">
      Thanks for your query. We will contact with you soon.
    </p>
  );
};

function ContactUsForm({ formStyle }) {

  // Extracting methods and variables from context
  const { submitTestimonial, isLoading } = useTestimonialContext();

  // State variables
  const [result, setResult] = useState(false);
  const [testimonialForm, setTestimonialForm] = useState({
    name: null,
    details: null,
    designation: null,
    course: null,
  });

  // Constant functions
  const handleChange = (e) => {
    try {
      let existingEnquiryForm = testimonialForm;
      existingEnquiryForm = {
        ...testimonialForm,
        [e.target.name]: e.target.value,
      };
      setTestimonialForm(existingEnquiryForm);
    } catch (error) {
      console.log("43 : TestimonialForm : Error while changing input value :: ", error && JSON.stringify(error));
    }
  };

  const handleSubmitTestimonial = (e) => {
    try {
      triggerFunction(
        GoogleAnalyticsEnum.BUTTON,
        GoogleAnalyticsEnum.CONTACT_US_FORM_SUBMIT_BUTTON
      );
      e.preventDefault();
      submitTestimonial({
        ...testimonialForm,
      });
      e.target.reset();
      setResult(true);
    } catch (error) {
      console.log("48 : TestimonialForm : Error while submitting testimonial :: ", error && JSON.stringify(error));
    }
  };

  setTimeout(() => {
    setResult(false);
  }, 5000);

  return (
    // Adding disabled property in input box and button start here
    <form
      className={`${formStyle}`}
      action=""
      onSubmit={handleSubmitTestimonial}
    >
      <div className="col-lg-12">
        <div className="form-group">
          <input
            disabled={isLoading}
            type="text"
            className="form-control form-control-lg"
            name="name"
            placeholder="Name*"
            required
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group">
          <input
            disabled={isLoading}
            type="text"
            className="form-control form-control-lg"
            name="details"
            placeholder="Details*"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-12">
        <div className="form-group">
          <div className="custom-dropdown">
            <select
              disabled={isLoading}
              className="form-control form-control-lg"
              name="designation"
              placeholder="Please select your Designation"
              onChange={handleChange}
            >
              <option value="">Please select your Designation</option>
              <option value="Student">Student</option>
              <option value="Developer">Developer</option>
              <option value="Designer">Designer</option>
              <option value="Tester">Tester</option>
            </select>
            <div className="dropdown-icon"></div>
          </div>
        </div>
      </div>

      <div className="col-lg-12">
        <div className="form-group">
          <select
            disabled={isLoading}
            className="form-control form-control-lg"
            name="course"
            onChange={handleChange}
          >
            <option value="">Please select your Course</option>
            <option value="Salesforce">Salesforce</option>
          </select>
        </div>
      </div>

      <div className="col-lg-12">
        {/* Adding Spinner icon Start Here */}
        {!isLoading && (
          <button
            disabled={isLoading}
            className={"rn-btn edu-btn w-100"}
            type={"submit"}
          >
            <span>Submit Now</span>
            <i className="icon-arrow-right-line-right"></i>
          </button>
        )}
        {isLoading && (
          <button
            disabled={isLoading}
            className={"rn-btn edu-btn w-100 btn-loading"}
            type={"submit"}
          >
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        )}
        {/* Adding Spinner icon Start Here */}
      </div>
      {result ? (
        <div className="form-group">
          <Result />
        </div>
      ) : null}
    </form>
    // Adding disabled property in input box and button End here
  );
}
export default ContactUsForm;
